import {
    ErrorGuardCallbackOptions,
    ErrorGuardConfig,
    createAsyncErrorGuard,
    createErrorGuard,
} from '@superbet-group/web.lib.vue-utilities';

import { logger } from '@utils/logger';

let errorGuardInstance: <T>(
    action: () => T,
    callbackOptions: ErrorGuardCallbackOptions | undefined,
) => Promise<T | undefined> = async <T>(action: () => T) => {
    try {
        return await action();
    } catch (error) {
        logger.error(error as Error);
    }
};

export function initErrorGuard(config: ErrorGuardConfig) {
    errorGuardInstance = createErrorGuard(logger, config);
}

export function errorGuard<T>(
    action: () => T,
    callbackOptions?: ErrorGuardCallbackOptions,
): Promise<T | undefined> {
    // eslint-disable-next-line sonarjs/no-extra-arguments
    return errorGuardInstance(action, callbackOptions);
}
export const asyncErrorGuard = createAsyncErrorGuard(logger);
